import { Box } from '@mui/material';
import { HeartIcon } from '@synergy/theme-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';

import { EmptyState } from '../../components/empty-state/empty-state';
import { EmptyStateContent } from '../../components/empty-state/empty-state-content';
import { EmptyStateTitle } from '../../components/empty-state/empty-state-title';

export const WishListEmpty = (): ReactElement => {
    return (
        <Box sx={{ pb: 22, pt: { xs: 8, sm: 22 }, margin: 'auto' }}>
            <EmptyState icon={<HeartIcon fontSize="inherit" />}>
                <EmptyStateTitle>
                    <PoolFormattedMessage id="app.empty.wishList.title" />
                </EmptyStateTitle>
                <EmptyStateContent>
                    <PoolFormattedMessage id="app.empty.wishList.content" />
                </EmptyStateContent>
            </EmptyState>
        </Box>
    );
};
